"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.delay = exports.sendAndWaitForConfirmations = exports.parseEvents = exports.contract = void 0;
const bignumber_js_1 = __importDefault(require("bignumber.js"));
const utils_1 = require("./utils");
const network_1 = require("./network");
function contract(abi, address, options, w3) {
    const c = new (w3 !== null && w3 !== void 0 ? w3 : (0, network_1.web3)()).eth.Contract(abi, address, options);
    c.handleRevert = false;
    return c;
}
exports.contract = contract;
function parseEvents(receipt, contractOrAbi) {
    var _a, _b, _c;
    const abi = ((_a = contractOrAbi === null || contractOrAbi === void 0 ? void 0 : contractOrAbi.options) === null || _a === void 0 ? void 0 : _a.jsonInterface) || contractOrAbi;
    const abiCoder = (0, network_1.web3)().eth.abi;
    const abiEvents = abi.filter((desc) => desc.type === "event").map((desc) => ({
        name: desc.name || "",
        inputs: desc.inputs || [],
        signature: abiCoder.encodeEventSignature(desc),
    }));
    const result = [];
    (_b = receipt === null || receipt === void 0 ? void 0 : receipt.events) === null || _b === void 0 ? void 0 : _b.forEach((e) => {
        var _a, _b;
        const abiEvent = abiEvents.find((desc) => { var _a; return desc.signature === ((_a = e.raw) === null || _a === void 0 ? void 0 : _a.topics[0]); });
        if (abiEvent)
            result.push(Object.assign(Object.assign({}, e), { event: abiEvent.name, returnValues: abiCoder.decodeLog(abiEvent.inputs, ((_a = e.raw) === null || _a === void 0 ? void 0 : _a.data) || "", ((_b = e.raw) === null || _b === void 0 ? void 0 : _b.topics.slice(1)) || []) }));
    });
    (_c = receipt === null || receipt === void 0 ? void 0 : receipt.logs) === null || _c === void 0 ? void 0 : _c.forEach((log) => {
        const abiEvent = abiEvents.find((desc) => desc.signature === log.topics[0]);
        if (abiEvent)
            result.push(Object.assign({ event: abiEvent.name, returnValues: abiCoder.decodeLog(abiEvent.inputs, log.data, log.topics.slice(1)) }, log));
    });
    return result;
}
exports.parseEvents = parseEvents;
function sendAndWaitForConfirmations(tx, opts, confirmations = 0, autoGas, callback) {
    var _a, _b;
    return __awaiter(this, void 0, void 0, function* () {
        if (!tx && !opts.to)
            throw new Error("tx or opts.to must be specified");
        const [nonce, chain, price] = yield Promise.all([(0, network_1.web3)().eth.getTransactionCount(opts.from), (0, network_1.chainId)(), autoGas ? (0, network_1.estimateGasPrice)() : Promise.resolve()]);
        const maxFeePerGas = bignumber_js_1.default.max(autoGas ? ((_a = price === null || price === void 0 ? void 0 : price[autoGas]) === null || _a === void 0 ? void 0 : _a.max) || 0 : 0, (0, utils_1.bn)(opts.maxFeePerGas || 0), 0);
        const maxPriorityFeePerGas = bignumber_js_1.default.max(autoGas ? ((_b = price === null || price === void 0 ? void 0 : price[autoGas]) === null || _b === void 0 ? void 0 : _b.tip) || 0 : 0, (0, utils_1.bn)(opts.maxPriorityFeePerGas || 0), 0);
        const options = {
            value: opts.value ? (0, utils_1.bn)(opts.value).toFixed(0) : 0,
            from: opts.from,
            to: opts.to,
            gas: 0,
            nonce,
            maxFeePerGas: maxFeePerGas.isZero() ? undefined : maxFeePerGas.toFixed(0),
            maxPriorityFeePerGas: maxPriorityFeePerGas.isZero() ? undefined : maxPriorityFeePerGas.toFixed(0),
        };
        if (!(0, network_1.network)(chain).eip1559) {
            options.gasPrice = options.maxFeePerGas;
            delete options.maxFeePerGas;
            delete options.maxPriorityFeePerGas;
        }
        const estimated = yield ((tx === null || tx === void 0 ? void 0 : tx.estimateGas(Object.assign({}, options))) || (0, network_1.web3)().eth.estimateGas(Object.assign({}, options)));
        options.gas = Math.floor(estimated * 1.2);
        const promiEvent = tx ? tx.send(options) : (0, network_1.web3)().eth.sendTransaction(options);
        let sentBlock = Number.POSITIVE_INFINITY;
        let receipt;
        let txHash = "";
        promiEvent.once("transactionHash", (r) => {
            var _a;
            txHash = r;
            (_a = callback === null || callback === void 0 ? void 0 : callback.onTxHash) === null || _a === void 0 ? void 0 : _a.call(callback, r);
        });
        try {
            receipt = yield promiEvent;
        }
        catch (error) {
            if (!error.message.toLowerCase().includes("failed to check for transaction receipt")) {
                throw error;
            }
        }
        if (!receipt) {
            receipt = yield waitForReceipt(txHash);
        }
        if (!receipt) {
            throw new Error("Transaction failed");
        }
        if (confirmations > 1) {
            while ((yield (0, network_1.web3)().eth.getTransactionCount(opts.from)) === nonce || (yield (0, network_1.web3)().eth.getBlockNumber()) < receipt.blockNumber + confirmations) {
                yield new Promise((r) => setTimeout(r, 1000));
            }
        }
        return receipt;
    });
}
exports.sendAndWaitForConfirmations = sendAndWaitForConfirmations;
function delay(ms) {
    return new Promise((resolve) => setTimeout(resolve, ms));
}
exports.delay = delay;
function waitForReceipt(txHash) {
    return __awaiter(this, void 0, void 0, function* () {
        for (let i = 0; i < 30; ++i) {
            yield delay(1000);
            try {
                const receipt = yield (0, network_1.web3)().eth.getTransactionReceipt(txHash);
                if (receipt) {
                    return receipt;
                }
            }
            catch (error) {
                console.error("waitForReceipt error", error);
            }
        }
    });
}
